import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import SelectObject from "../../../ui/SelectObject";
import { AssessmentLineChart } from "../../../report-ui/AssessmentLineChart";

const CustomAssessments = ({ assessments, assessmentType }: any) => {
  const [questionAverages, setQuestionAverages] = useState<any>();
  const [trend, setTrend] = useState<any>();
  const [selectedQuestion, setSelectedQuestion] = useState<any>();

  useEffect(() => {
    calculateQuestions(assessments);
    calculateTrend(assessments);
  }, [assessments]);

  const updateQuestion = (e: any) => {
    setSelectedQuestion(e);
    if (e !== "0") {
      const question = assessmentType?.original?.question.find((q: any) => q.key === e);
      const filteredAssessments = assessments.filter((a: any) => a?.question === question?.question);
      calculateTrend(filteredAssessments);
    } else {
      calculateTrend(assessments);
    }
  };

  const calculateQuestions = (data: any) => {
    const grouped = Object.values(
      data?.reduce((acc: any, curr: any) => {
        const id = curr.assessmenttype_field_id;
        const value = parseFloat(curr.value); // Convert string to number

        if (!acc[id]) {
          acc[id] = {
            assessmenttype_field_id: id,
            question: curr.question,
            total: 0,
            count: 0,
          };
        }

        acc[id].total += value;
        acc[id].count += 1;

        return acc;
      }, {}),
    ).map((group: any) => ({
      assessment_type_field_id: group.assessmenttype_field_id,
      question: group.question,
      average: parseFloat((group.total / group.count).toFixed(2)),
    }));

    setQuestionAverages(grouped);
  };

  const calculateTrend = (data: any[]) => {
    const groupedData: { [date: string]: { sum: number; count: number } } = data.reduce((acc: any, obj: any) => {
      const date = obj.assessment_at;
      const value = parseFloat(obj.value); // Convert string to number

      if (!acc[date]) {
        acc[date] = { sum: 0, count: 0 };
      }
      acc[date].sum += value;
      acc[date].count++;
      return acc;
    }, {});

    // Calculate average for each group
    const averagedData = Object.entries(groupedData).map(([date, { sum, count }]) => ({
      date,
      score: sum / count,
    }));

    setTrend(averagedData);
  };

  return (
    <>
      <Container id="custom-section" className="lg vstack gap-3">
        {trend?.length > 0 ? (
          <>
            <Row>
              <h5 className="app-header-text text-center">{assessmentType?.name}</h5>
              {assessmentType?.original?.is_archived && (
                <label className="note-type text-muted text-center">
                  {"Archived: " +
                    (assessmentType?.original?.archived_at ? new Date(assessmentType?.original?.archived_at).toLocaleDateString() : "")}
                </label>
              )}
            </Row>
            <Row className="justify-content-center gap-3 mt-3">
              {questionAverages?.map((q: any) => (
                <Col xs={12} md={8}>
                  <Card className="bg-light">
                    <Card.Body>
                      <Row className="text-center">
                        <Col xs={9} className="d-flex align-items-center">
                          <h5 className="app-orange-text text-start mb-0">{q?.question}</h5>
                        </Col>
                        <Col xs={3} className="d-flez justify-content-center align-items-center">
                          <h2 className="text-muted">{q?.average}</h2>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row className="my-3">
              <Col></Col>
              <Col className="col-8">
                <SelectObject
                  label="Question"
                  value={selectedQuestion}
                  options={assessmentType?.original?.question}
                  onUpdate={(e: any) => updateQuestion(e.target.value)}
                />
              </Col>
              <Col></Col>
            </Row>
            <Row className="mb-5">
              <Col></Col>
              <Col className="col-8">
                <AssessmentLineChart titleText={assessmentType?.label} data={trend} assessType={assessmentType} />
              </Col>
              <Col></Col>
            </Row>
          </>
        ) : (
          <p className="mt-2">No Assessment Data</p>
        )}
      </Container>
    </>
  );
};

export default CustomAssessments;
